
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({ name: 'SortInlineEdit' })
export default class extends Vue {
  @Prop({ default: null }) private value!: string | number | null
  @Prop({ default: false }) private disabled!: boolean

  private editing = false
  private draft = ''
  private committing = false

  get display() {
    if (this.value === null || this.value === undefined || this.value === '') {
      return '—'
    }
    return String(this.value)
  }

  private startEdit() {
    if (this.disabled) return
    this.draft = this.display === '—' ? '' : this.display
    this.editing = true
    this.$nextTick(() => {
      const el: any = this.$refs.input
      if (el && typeof el.focus === 'function') {
        el.focus()
        if (typeof el.select === 'function') el.select()
      }
    })
  }

  private onInput(e: Event) {
    const raw = ((e.target as HTMLInputElement).value || '').replace(/[^\d]/g, '')
    this.draft = raw
    ;(e.target as HTMLInputElement).value = raw
  }

  private cancel() {
    this.editing = false
    this.draft = this.display === '—' ? '' : this.display
  }

  private commit() {
    if (this.committing || !this.editing) return
    this.committing = true
    const raw = String(this.draft || '').trim()
    if (raw === '') {
      this.editing = false
      this.committing = false
      return
    }
    const n = Number(raw)
    if (!Number.isFinite(n) || n < 1 || Math.floor(n) !== n) {
      this.$message.warning('请填写想排的第几位（从1开始的整数）')
      this.editing = false
      this.committing = false
      return
    }
    const cur =
      this.value === null || this.value === undefined || this.value === ''
        ? null
        : Number(this.value)
    this.editing = false
    this.committing = false
    if (cur === n) return
    this.$emit('change', n)
  }
}
